// extracted by mini-css-extract-plugin
module.exports = {"root":"Image-module--root--T2Oi4"};